<template>
  <div class="join">
    <el-dialog width="500px" :title="popTitle" :visible.sync="showEditMember">
      <edit-operator v-if="showEditMember" :memberInfo='memberInfo' :id="id"></edit-operator>
    </el-dialog>
    <el-dialog width="500px" title="修改密码" :visible.sync="showEditPass">
      <edit-pass v-if="showEditPass" :id="id"></edit-pass>
    </el-dialog>
    <div class="title"><img src="../assets/circle.png"><b>运维人员列表</b></div>
    <div class="searchDiv">
      <div class="searchDivLeft">
        <el-select class="selectValue" v-model="selectValue" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
        </el-select>
        <el-input v-model="keyword" :placeholder="placeholder"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button></div>
      <div class="searchDivRight"><el-button type="primary" @click="eidtMemberFn('','add')">添加</el-button></div>
    </div>
    <div class="joinList">
      <table class="activeTable" cellspacing="0" cellpadding="0">
        <tr><th width="6%">序号</th><th width="10%">姓名</th><th width="10%">电话</th><th width="10%">省份</th><th width="13%">所属公司</th><th width="13%">厂家</th><th width="25%">操作</th></tr>
        <tr v-for="(item,index) in joinList" :key="item.id">
          <td align="center">{{index+(cur-1)*10+1|cutserial}}</td>
          <td align="center"><span :title="item.trueName">{{item.trueName}}</span></td>
          <td align="center">{{item.phone}}</td>
          <td align="center">{{item.city}}</td>
          <td align="center"><span :title="item.showCompany">{{item.showCompany|cutstr(12)}}</span></td>
          <td align="center"><span :title="item.company">{{item.company|cutstr(12)}}</span></td>
          <td align="center" class="options"><span @click='viewCustomer(item.id)'>客户</span><span @click="rebind(item.id)">设备</span><span @click="eidtMemberFn(index,'edit',item.id)">修改</span><span @click="eidtPassFn(item.id)">修改密码</span><span @click="deleteOperator(item.id)">删除</span></td>
        </tr>
      </table>
      <div class="nodata" v-if="showNodata"><img src="../assets/no_data.png"><p>暂无数据</p></div>
    </div>
    <div class="page" v-if="!showNodata"><page :total='total' :currentPage=cur :pageSize='pageSize' @pageNum="getPage"></page></div>
    <loading v-if="showLoading"></loading>
  </div>
</template>

<script>
import {getOperatorList,deleteOperator} from '@/api/api'
import bus from '@/bus'
import Page from '@/components/Page'
import {formatDate} from '@/api/common'
import EditOperator from '@/components/EditOperator'
import EditPass from '@/components/EditPass'
import Loading from '@/components/Loading'
export default {
  name: 'oprator',
  data () {
    return {
      popTitle:'',
      joinList:[],
      memberInfo:{},
      id:'',
      keyword:'',
      showNodata:false,
      showEditMember:false,
      showEditPass:false,
      showLoading:false,
      pageSize: 10, //每页几条
      cur: 1,//当前页码
      total:0 ,//总条数
      oldOperatorId:'',
       options: [{
                value: '按省级',
                label: '按省级'
              },
              {
                value: '按公司',
                label: '按公司'
              },
              {
                value: '按姓名',
                label: '按姓名'
              },{
                value: '按电话',
                label: '按电话'
              }],
      selectValue: '按姓名',
      placeholder:'请输入姓名查询'
    }
  },
  mounted(){
    bus.$off('hidePop')
    bus.$on('hidePop',res=>{
      this.showEditMember=res
    })
    bus.$off('closeEditPass')
    bus.$on('closeEditPass',res=>{
      this.showEditPass=res
    })
    bus.$off('closeEditMember')
    bus.$on('closeEditMember',res=>{
      this.showEditMember=false
      this.getData()
    })
    this.getData()
  },
  methods:{
    eidtPassFn(id){
      this.showEditPass=true
      this.id=id
    },
    viewCustomer(id){
      this.$router.push({path:'/operatorcustomer',query:{id}})
    },
    rebind(id){
      this.oldOperatorId=id
      this.$router.push({path:'operatorDevice',query:{id}})
    },
    search(){
      this.cur=1
      this.getData(this.keyword)
    },
    eidtMemberFn(index,type,id){
      if(type=='add'){
        this.id=''
        this.popTitle='添加运维'
      }else{
        this.popTitle='修改运维'
        this.id=id
        this.memberInfo=this.joinList[index]
      }
      this.showEditMember=true
    },
    getData(key){
      if(this.selectValue=='按姓名'){
        var data=JSON.stringify({
          "trueName":key,
          "pageSize":this.pageSize,
          "currentPage":this.cur,
          })
      }
      if(this.selectValue=='按省级'){
        var data=JSON.stringify({
          "city":key,
          "pageSize":this.pageSize,
          "currentPage":this.cur,
          })
      }
      if(this.selectValue=='按电话'){
        var data=JSON.stringify({
          "phone":key,
          "pageSize":this.pageSize,
          "currentPage":this.cur,
          })
      }
      if(this.selectValue=='按公司'){
        var data=JSON.stringify({
          "showCompany":key,
          "pageSize":this.pageSize,
          "currentPage":this.cur,
          })
      }
      this.showLoading=true
      getOperatorList(data).then(res=>{
        this.showLoading=false
        if(res.data.state==200){
          const {data}=res.data
          if(data==''||data==null){
            this.showNodata=true
          }else{
            this.showNodata=false
          }
          this.total=res.data.totalCount
          this.joinList=data
        }
      }).catch(err=>{
        this.showLoading=false
      })
    },
    deleteOperator(id){
      this.$confirm('是否删除该运维人员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data=JSON.stringify({
          devOpsId:id
        })
        deleteOperator(data).then(res=>{
           if(res.data.state==200){
             this.getData()
             this.$message({
                message: '删除成功',
                type: 'success'
             })
           }else{
             this.$message({
                message: '操作失败',
                type: 'warning'
             })
           }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    getPage(data){
      this.cur=data
    }
  },
  filters:{
    getTime(time) {
     var date = new Date(time);
     return formatDate(date, 'yyyy-MM-dd h:m:s').slice(0,16);
    },
    cutstr(val,len){
      if(val&&val.length>len){
        return val.slice(0,len)+'...'
      }else{
        return val
      }
    },
    cutserial(val){
       var len=val.toString().length
        if(len==1){
          return '00'+val
        }
        if(len==2){
          return '0'+val
        }
    }
  },
  watch:{
    cur(val){
      this.getData(this.keyword)
    },
    selectValue(val){
      if(val=='按姓名'){
        this.placeholder="请输入姓名查询"
      }
      if(val=='按省级'){
        this.placeholder="请输入所在省查询"
      }
      if(val=='按电话'){
        this.placeholder="请输入电话查询"
      }
      if(val=='按公司'){
        this.placeholder="请输入公司名称查询"
      }
    }
  },
  components:{
    Page,
    EditOperator,
    EditPass,
    Loading
  },
  beforeRouteEnter(to,from,next) {
    var that=this
    var manager=localStorage.getItem('loginState')
    if(manager=='Y'){
      next()
    }else{
       alert('您没有访问权限')
       next('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .searchDiv {height:50px;line-height:50px;}
   .el-input {width:250px;margin-right:10px;}
   .joinList {height:500px;margin-top:20px;}
   .activeTable {width:100%;margin-top:5px;}
   .activeTable tr {height:40px;line-height:45px;}
   .activeTable tr input {width:16px;height:16px;position:relative;top:2px;}
   .activeTable tr th {font-weight: 100;background:#f6f6f6;}
   .activeTable tr td {border-bottom: #eee 1px solid;}
   .page {height:50px;}
   .searchDivLeft {width:600px;float: left;}
   .searchDivRight {width: 300px;text-align: right;float: right;}
   .options span {color:#fff;font-size:12px;padding:7px 10px;border-radius:4px;margin-left:5px;margin-right:5px;background:#409eff;cursor: pointer;}
   .selectValue {width:100px;}
</style>



// WEBPACK FOOTER //
// src/views/Operator.vue